import { useLocalStoreWithDep } from "designSystem/hooks";
import React, { FunctionComponent } from "react";
import { SingleSelectComponent } from "../index";
import { EnumProps, EnumStore } from "./EnumStore";

export const Enum: FunctionComponent<EnumProps> = ({ attributeId, nodeType, nodeUrl, reportOperations }) => {
	const enumStore = useLocalStoreWithDep(() => new EnumStore(attributeId, nodeType, nodeUrl, reportOperations), [reportOperations]);

	return (
		<SingleSelectComponent aggregateStore={enumStore?.store} />
	);
};
